import React, { useState, useEffect } from "react";
import { useCookies } from "../../hooks/useCookies";
import "./cookies.scss";

const CookieSetting = () => {
  const { createTheCookies, getTheCookies, updateTheCookies } = useCookies();
  const [userExist, setUserExist] = useState(false);
  const [marketingCookiesCheck, setMarketingCookiesCheck] = useState(false);
  const [personalizationCookiesCheck, setpersonalizationCookiesCheck] =
    useState(false);
  const [analyticsCookiesCheck, setanalyticsCookiesCheck] = useState(false);
  const userId = localStorage.getItem("userId");
  const [successMessage, setSuccessMessage] = useState("");

  let functionalCookies = true;

  useEffect(() => {
    if (!userId) {
      console.error("this user does not exit");
      return;
    }

    const fetchData = async () => {
      const data = await getTheCookies(userId);
      if (data === 404) {
        console.log("user is not exist");
        setUserExist(false);
      } else {
        setUserExist(true);
        setMarketingCookiesCheck(data.marketingCookies);
        setpersonalizationCookiesCheck(data.personalizationCookies);
        setanalyticsCookiesCheck(data.analyticsCookies);
      }
    };
    // call the function
    fetchData()
      // make sure to catch any error
      .catch(console.error);

    // eslint-disable-next-line
  }, []);

  const handleSavePreferences = async () => {
    try {
      if (userExist) {
        // Use the latest checked values directly in the function call
        await updateTheCookies(
          userId,
          functionalCookies,
          personalizationCookiesCheck,
          analyticsCookiesCheck,
          marketingCookiesCheck
        );
      } else {
        await createTheCookies(
          userId,
          functionalCookies,
          personalizationCookiesCheck,
          analyticsCookiesCheck,
          marketingCookiesCheck
        );
      }
      setSuccessMessage(
        "Your cookie preferences have been successfully updated."
      );
    } catch (error) {
      console.log("Error saving preferences:", error);
      setSuccessMessage("We faced a problem, please try later!");
    }
  };

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage("");
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  return (
    <>
      {successMessage && <div className="message-box">{successMessage}</div>}

      <div>
        <div className="cookie-text">
          <p>
            When you visit websites, they may store or retrieve data in your
            browser. This storage is often necessary for the basic functionality
            of the website. The storage may be used for marketing, analytics,
            and personalization of the site, such as storing your preferences.
            Privacy is important to us, so you have the option of disabling
            certain types of storage that may not be necessary for the basic
            functioning of the website. Blocking categories may impact your
            experience on the website.
          </p>
          <a
            href="https://oncoscreen.health/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy policy
          </a>
        </div>

        <div className="cookie-category">
          <div className="form-check form-switch">
            <label className="form-check-label" htmlFor="essentialCookies">
              Essential
            </label>
            <input
              className="form-check-input mt-0"
              type="checkbox"
              id="essentialCheck"
              defaultChecked
              disabled
            />
          </div>

          <p>
            These are cookies which are strictly necessary for the operation of
            our website and for this reason no consent is necessary
            <li>Authentication cookies stored when you login to our website</li>
            <li> Technical cookies required by certain IT Systems</li>
          </p>
        </div>
        <div className="cookie-category">
          <div className="form-check form-switch">
            <label className="form-check-label" htmlFor="marketingCheck">
              Marketing
            </label>
            <input
              className="form-check-input mt-0"
              type="checkbox"
              id="marketingCheck"
              checked={marketingCookiesCheck}
              onChange={(e) => setMarketingCookiesCheck(e.target.checked)}
            />
          </div>
          <p>
            These items are used to deliver advertising that is more relevant to
            you and your interests. They may also be used to limit the number of
            times you see an advertisement and measure the effectiveness of
            advertising campaigns. Advertising networks usually place them with
            the website operator’s permission.
          </p>
        </div>
        <div className="cookie-category">
          <div className="form-check form-switch">
            <label className="form-check-label" htmlFor="personalizationCheck">
              Personalization
            </label>
            <input
              className="form-check-input mt-0"
              type="checkbox"
              id="personalizationCheck"
              checked={personalizationCookiesCheck}
              onChange={(e) => setpersonalizationCookiesCheck(e.target.checked)}
            />
          </div>

          <p>
            These items allow the website to remember choices you make (such as
            your user name, language, or the region you are in) and provide
            enhanced, more personal features. For example, a website may provide
            you with local weather reports or traffic news by storing data about
            your current location.
          </p>
        </div>
        <div className="cookie-category">
          <div className="form-check form-switch">
            <label className="form-check-label" htmlFor="analyticsChech">
              Analytics
            </label>
            <input
              className="form-check-input mt-0"
              type="checkbox"
              id="analyticsChech"
              checked={analyticsCookiesCheck}
              onChange={(e) => setanalyticsCookiesCheck(e.target.checked)}
            />
          </div>

          <p>
            These items help the website operator understand how its website
            performs, how visitors interact with the site, and whether there may
            be technical issues. This storage type usually doesn’t collect
            information that identifies a visitor.
          </p>
        </div>
        <div className="row cookie-category">
          <div className="col">
            <button
              className="reset-consent-button btn btn-success  px-3 py-1 fw-bold"
              id="save-cookies"
              onClick={handleSavePreferences}
            >
              Save preferences
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieSetting;
